type INTEREST_TYPE = { [key: string]: string }

export const INTEREST_TYPE: INTEREST_TYPE = {
  monthly: 'Mensal',
  daily: 'Diário'
}
